/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocks_Market_News_TitleInputs */

const en_stocks_market_news_title = /** @type {(inputs: Stocks_Market_News_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Market news`)
};

const de_stocks_market_news_title = /** @type {(inputs: Stocks_Market_News_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marktnachrichten`)
};

const pt_br2_stocks_market_news_title = /** @type {(inputs: Stocks_Market_News_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notícias do mercado`)
};

const tr_stocks_market_news_title = /** @type {(inputs: Stocks_Market_News_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piyasa haberleri`)
};

const zh_cn2_stocks_market_news_title = /** @type {(inputs: Stocks_Market_News_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`市场资讯`)
};

const zh_hk2_stocks_market_news_title = /** @type {(inputs: Stocks_Market_News_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`市場新聞`)
};

const ko_kr2_stocks_market_news_title = /** @type {(inputs: Stocks_Market_News_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`마켓 뉴스`)
};

const ru_ru2_stocks_market_news_title = /** @type {(inputs: Stocks_Market_News_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новости рынка`)
};

const es_419_stocks_market_news_title = /** @type {(inputs: Stocks_Market_News_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noticias del mercado`)
};

/**
* | output |
* | --- |
* | "Market news" |
*
* @param {Stocks_Market_News_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const stocks_market_news_title = /** @type {((inputs?: Stocks_Market_News_TitleInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocks_Market_News_TitleInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_stocks_market_news_title(inputs)
	if (locale === "de") return de_stocks_market_news_title(inputs)
	if (locale === "pt-BR") return pt_br2_stocks_market_news_title(inputs)
	if (locale === "tr") return tr_stocks_market_news_title(inputs)
	if (locale === "zh-CN") return zh_cn2_stocks_market_news_title(inputs)
	if (locale === "zh-HK") return zh_hk2_stocks_market_news_title(inputs)
	if (locale === "ko-KR") return ko_kr2_stocks_market_news_title(inputs)
	if (locale === "ru-RU") return ru_ru2_stocks_market_news_title(inputs)
	return es_419_stocks_market_news_title(inputs)
});